module.exports = __webpack_public_path__ + "img/ico_makeshop.f11be1dc.svg";